import { createContext } from 'react';

export const InsuranceCooperationAuthenticationContext = createContext({});
